
import PopupController from '@/assets/ts/controller/PopupController';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class RegistroPontoKeypad extends Vue {
  //#region [ PROPS ]
  @Prop({ default: false })
  readonly plusBtnWorks: boolean;
  //#endregion



  //#region [ EVENTS ]
  @Emit('key-pressed')
  emitKeyPressed(key: string): void {}

  @Emit('backspace')
  emitBackspace(): void {}

  @Emit('ponto-btn-clicked')
  emitPontoBtnClicked(): void {}

  @Emit('clear')
  emitClear(): void {}
  //#endregion



  //#region [ DATA ]
  keypadAspectRatio: number = 1; // Default aspect ratio
  //#endregion



  //#region [ COMPUTED ]
  get ignoreKeyboardEvents(): boolean {
    const confirmPasswordPopup: any = this.$store.state.popUp.popUps.find(
      (popUp: any) => popUp.name === PopupController.POPUP_NAMES.CONFIRM_PASSWORD);

    return confirmPasswordPopup && confirmPasswordPopup.isVisible;
  }
  //#endregion



  //#region [ LIFECYCLE ]
  mounted() {
    window.addEventListener('keydown', this.handleKeyPress);
    window.addEventListener('resize', this.updateKeypadSize);
    this.calculateKeypadAspectRatio();
    this.updateKeypadSize();
  }

  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyPress);
    window.removeEventListener('resize', this.updateKeypadSize);
  }
  //#endregion



  //#region [ METHODS ]
  backspaceHoldTimeout: number | null = null;
  backspaceHeld: boolean = false;

  handleBackspaceDown() {
    if (this.ignoreKeyboardEvents) {
      return;
    }

    this.backspaceHeld = true;
    this.backspaceHoldTimeout = window.setTimeout(() => {
      if (this.backspaceHeld) {
        this.emitClear();
      }
    }, 500);
  }

  handleBackspaceUp() {
    this.backspaceHeld = false;
    if (this.backspaceHoldTimeout) {
      clearTimeout(this.backspaceHoldTimeout);
      this.backspaceHoldTimeout = null;
    }
  }

  handleKeyPress(event: KeyboardEvent) {
    if (this.ignoreKeyboardEvents) {
      return;
    }

    const validKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Enter'];
    const key = event.key;

    if (!validKeys.includes(key)) {
      return;
    }

    if (!isNaN(Number(key)) && key.length === 1) {
      this.emitKeyPressed(key);
    } else if (key === 'Backspace') {
      this.emitBackspace();
    } else if (key === 'Enter') {
      this.emitPontoBtnClicked();
    }
  }

  calculateKeypadAspectRatio(): void {
    const keypad: HTMLDivElement = this.$el.querySelector('.keypad');
    if (keypad) {
      this.keypadAspectRatio =  keypad.clientWidth / keypad.clientHeight;
    }
  }

  updateKeypadSize() {
    const keypad: HTMLDivElement = this.$el.querySelector('.keypad');

    if (keypad) {
      const wrapper = keypad.parentElement;
      const wrapperAspectRatio = wrapper.clientWidth / wrapper.clientHeight;

      if (this.keypadAspectRatio > wrapperAspectRatio) {
        keypad.style.width = '100%';
        keypad.style.height = 'auto';
      } else {
        keypad.style.width = 'auto';
        keypad.style.height = '100%';
      }
    }
  }
  //#endregion
}
